import { render, staticRenderFns } from "./OrganizationTeam.vue?vue&type=template&id=6a53606e"
import script from "./OrganizationTeam.vue?vue&type=script&lang=js"
export * from "./OrganizationTeam.vue?vue&type=script&lang=js"
import style0 from "./OrganizationTeam.vue?vue&type=style&index=0&id=6a53606e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports